import React, { useEffect, useState } from 'react'
import { Link, useLoaderData } from 'react-router-dom'
import { getCases, queryCases } from '../../adapters/caseResolution';
import { InputField } from '../../components/Input';
import { LoadingData } from '../../components/Loading';
import { formatDate } from '../../utils/methods';

export default function Dashboard() {

  const [visiblePane, setVisiblePane] = useState(1);
  const [searchTxt, setSearchTxt] = useState('');
  const [proceedingData, setProceedingData ] = useState();

  const [filteredCases, setFilteredCases] = useState([]);
  const [loadingState, setLoadingState] = useState(false);
  const [caseData, setCaseData] = useState(null);
  const [queryReults, setQueryReults] = useState([])

  const serverData = useLoaderData();

  const paneTitles = [
    "Pending Resolution","Pending Settlement", "Pending Lodgement"
  ]

  useEffect(() => {
    setCaseData(serverData.cases);
    setProceedingData(serverData.proceedings);
  }, [serverData])
  
  useEffect(() => {
    if (caseData!== null && caseData.docs){
      setFilteredCases(caseData.docs)
    }
  }, [caseData])

  useEffect(() => {
    if(visiblePane > 2){
      queryCaseByStatus();
    }
  }, [visiblePane])

  const queryCaseByStatus = async () => {
    setLoadingState(true)
    const options = {
      gt: 1, lt: 2
    };
    switch (visiblePane) {
      case 3:
        options.gt = 2;
        options.lt = 5;
      break;
      case 4:
        options.gt = 1;
        options.lt = 4;
      break;
      case 5:
        options.gt = 3;
        options.lt = 6;
      break;
      default:
      break;
    }
    await queryCases(options).then((res) => {
      if(res.status === 200){
        setQueryReults(res.data);
        setLoadingState(false)
      }
    })
  }

  const getDataOnScroll = async () => {
    setLoadingState(true);
    if (caseData.hasNextPage) {
      const currentData = caseData;
      await getCases(caseData.nextPage).then((res) => {
        if (res.status === 200) {
          const newData = res.data;
          const docs = [...currentData.docs, ...newData.docs];
          const data = {
            ...newData,
            docs
          }

          setCaseData(data)
          setLoadingState(true);
        }
      })
    }
  }

  const searchCase = async () => {
    setLoadingState(true);
    const filteredItems = []
    caseData.docs.forEach(async (item) => {
      for await (let ic of item) {
        if (ic.name.includes(searchTxt)) {
          const existsInArray = filteredItems.find((fi) => fi._id === item._id)
          if (!existsInArray) {
            filteredItems.push(item);
          }
        }
      }

      for await (let id of item) {
        if (id.name.includes(searchTxt)) {
          const existsInArray = filteredItems.find((fi) => fi._id === item._id)
          if (!existsInArray) {
            filteredItems.push(item);
          }
        }
      }
    })
    setTimeout(() => {
      if (filteredItems.length) {
        setFilteredCases(filteredItems);
      }
      setLoadingState(false);
    }, 3000)
  }

  return (
    <div className="h-screen">
      <div className="wrapper animate__animated animate__fadeIn xl:py-16 py-12">
        <div className="gradient-bg rounded-lg py-10 px-8 flex lg:items-center lg:flex-row flex-col justify-start lg:justify-between items-start gap-4">
          <div>
            <h1 className="font-fira xl:text-3xl lg:text-2xl text-xl">u-Resolve Neutral Dashboard</h1>
            {/* <p className="text-xs lg:text-sm font-taviraj">Resolve your issues easily and risk free</p> */}
          </div>

          <Link to="/neutral/schedule-proceeding" className="text-white bg-blue-800 text-xs font-semibold px-6 py-2 rounded-lg border border-blue-800 hover:border-blue-900 hover:bg-blue-800 ">
            Schedule a Meeting
          </Link>
        </div>

        <div className="">
          <div className="mt-4 bg-gray-100 pb-6  rounded-lg border-2 border-gray-300">
            <div className="py-2 px-4 lg:px-8 border-b border-gray-500 overflow-x-scroll">
              {/* Pane Header */}
              <ul className="flex gap-8 items-center font-semibold font-fira">
                <li><a href="#!" onClick={(e) => { e.preventDefault(); setLoadingState(false); setVisiblePane(1) }} className={`px-3 transition-color ease-in-out delay-150 py-1 rounded-lg text-xs ${visiblePane === 1 ? 'bg-blue-900 text-white' : 'text-gray-800'}  whitespace-nowrap`}>Cases/Details</a></li>
                <li><a href="#!" onClick={(e) => { e.preventDefault(); setLoadingState(false); setVisiblePane(2) }} className={`px-3 transition-color ease-in-out delay-150 py-1 rounded-lg text-xs ${visiblePane === 2 ? 'bg-blue-900 text-white' : 'text-gray-800'} whitespace-nowrap`}>Upcoming Meetings</a></li>
                <li><a href="#!" onClick={(e) => {
                  e.preventDefault();
                  setLoadingState(false);
                  setVisiblePane(3);
                  queryCaseByStatus();
                }} className={`px-3 transition-color ease-in-out delay-150 py-1 rounded-lg text-xs ${visiblePane === 3 ? 'bg-blue-900 text-white' : 'text-gray-800'} whitespace-nowrap`}>Pending Resolution</a></li>
                <li><a href="#!" onClick={(e) => { 
                  e.preventDefault(); 
                  setLoadingState(false);
                  setVisiblePane(4);
                  queryCaseByStatus();
                }} className={`px-3 transition-color ease-in-out delay-150 py-1 rounded-lg text-xs ${visiblePane === 4 ? 'bg-blue-900 text-white' : 'text-gray-800'} whitespace-nowrap`}>Pending Settlements</a></li>
                <li><a href="#!" onClick={(e) => { 
                  e.preventDefault(); 
                  setLoadingState(false);
                  setVisiblePane(5);
                  queryCaseByStatus();
                }} className={`px-3 transition-color ease-in-out delay-150 py-1 rounded-lg text-xs ${visiblePane === 5 ? 'bg-blue-900 text-white' : 'text-gray-800'} whitespace-nowrap`}>Pending Lodgments</a></li>
              </ul>
            </div>
            {/* Pane Body */}
            <div className="">
              {visiblePane === 1 && <div className="py-4 px-4 lg:px-8">
                <div className="mt-3">
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    searchCase();
                  }}>
                    <div className="flex items-center md:gap-4 gap-0 md:justify-between justify-center md:flex-row flex-col">
                      <div className="md:w-10/12 w-full relative">
                        <InputField type='text' name="searchCase" defaultValue={searchTxt} id="searchText" className="" onChange={(e) => {
                          setSearchTxt(e.target.value)
                        }} withIcon={true} placeholder="Seach Case By Defendant's Name, Claimant's Name" />
                        <span className="absolute top-4 left-3">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                          </svg>
                        </span>

                        {searchTxt.length > 3 && <span className="absolute cursor-pointer top-4 right-3" onClick={() => {
                          setSearchTxt('');
                          searchCase();
                        }}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                            <path fillRule="evenodd" d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z" clipRule="evenodd" />
                          </svg>
                        </span>}
                      </div>
                      <div className="md:w-2/12 w-full mb-3">
                        <button onClick={searchCase} className="w-full text-xs font-semibold bg-blue-800 py-3 rounded-lg hover:bg-blue-900 text-white px-4">
                          Search Case
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="mt-4">
                  <div className="min-w-screen w-full overflow-x-scroll">
                    <table className="min-w-max w-full table-auto">
                      <thead className="text-xs font-fira bg-gray-200 rounded-t-lg">
                        <tr>
                          <th className="py-4 px-8 text-left">#</th>
                          <th className="py-4 px-8 text-left">Claimants</th>
                          <th className="py-4 px-8 text-left">Defendants</th>
                          <th className="py-4 px-8 text-left">Category</th>
                          <th className="py-4 px-8 text-left">Status</th>
                          <th className="py-4 px-8 text-left">Latest Upload</th>
                          <th className="py-4 px-8 text-left"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from(filteredCases).map((rc) => {
                          return (
                            <tr key={rc._id} className="border-b-2 font-semibold text-xs border-gray-200 hover:bg-gray-100">
                              <td className='py-4 px-8 text-left whitespace-nowrap'>{rc.uid}</td>
                              <td className='py-4 px-8 text-left whitespace-nowrap'>
                                <div className="flex items-center justify-center">
                                  {Array.from(rc.claimants).map((rcc) => {
                                    return (<img key={rcc._id} title={rcc.name} className="w-8 h-8 rounded-full border-gray-200 border transform hover:scale-125" src={rcc.avatar} alt="" />)
                                  })}
                                </div>
                              </td>
                              <td className='py-4 px-8 text-left whitespace-nowrap'>
                                <div className="flex items-center justify-center">
                                  {Array.from(rc.defendants).map((rcd) => {
                                    return (<img key={rcd._id} title={rcd.name} className="w-8 h-8 rounded-full border-gray-200 border transform hover:scale-125" src={rcd.avatar} alt="" />)
                                  })}
                                </div>
                              </td>
                              <td className='py-4 px-8 text-left whitespace-nowrap'>
                                <span>{rc.category}</span>
                              </td>
                              <td className='py-4 px-8 text-left whitespace-nowrap'>
                                <span>{rc.status}</span>
                              </td>
                              <td className='py-4 px-8 text-left whitespace-nowrap'>
                                <span>{formatDate(rc.updatedAt)}</span>
                              </td>
                              <td className='py-4 px-8 text-left whitespace-nowrap'>
                                <Link to={`/neutral/case-detail/${rc._id}`} className="border-2 border-blue-600 hover:bg-blue-300 text-blue-800 font-semibold rounded-lg py-1 px-3">
                                  See Details
                                </Link>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>}
              {visiblePane === 2 && <div className="py-6 px-6 lg:px-8">
                <h4 className="text-sm mb-4 font-semibold font-fira text-gray-800">
                  Upcoming Meetings
                </h4>
                <div className="mt-4 min-w-screen w-full overflow-x-scroll">
                  <table className="min-w-max w-full table-auto">
                    <thead className="text-xs font-fira bg-gray-100 whitespace-nowrap">
                      <tr>
                        <th className="py-3 px-3 text-left">#</th>
                        <th className="py-3 px-3 text-left">DATE</th>
                        <th className="py-3 px-3 text-left">TIME</th>
                        <th className="py-3 px-3 text-left">TYPE</th>
                        <th className="py-3 px-3 text-left">LINK</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.from(proceedingData).map((cp) => {
                        return (
                          <tr key={cp._id} className="border-b-2 font-semibold text-xs border-gray-200 hover:bg-gray-100">
                            <td className='py-3 px-3 text-left whitespace-nowrap'>{caseData.indexOf(cp)}</td>
                            <td className='py-3 px-3 text-left whitespace-nowrap'>{cp.date} </td>
                            <td className='py-3 px-3 text-left whitespace-nowrap'>{cp.time}</td>
                            <td className='py-3 px-3 text-left whitespace-nowrap'>{cp.type}</td>
                            <td className='py-3 px-3 text-left whitespace-nowrap'>
                              <a href={cp.link} target="_blank" className="hover:text-blue-900" rel="noreferrer">Open Meeting Link</a>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>}
              {visiblePane >= 3 && <div className="py-6 px-6 lg:px-8">
                <h4 className="text-sm mb-4 font-semibold font-fira text-gray-800">
                  {visiblePane === 3 && paneTitles[0]}
                  {visiblePane === 4 && paneTitles[1]}
                  {visiblePane === 5 && paneTitles[2]}
                </h4>

                <div className="mt-4">
                  <div className="min-w-screen w-full overflow-x-scroll">
                    <table className="min-w-max w-full table-auto">
                      <thead className="text-xs font-fira bg-gray-200 rounded-t-lg">
                        <tr>
                          <th className="py-4 px-8 text-left">#</th>
                          <th className="py-4 px-8 text-left">Claimants</th>
                          <th className="py-4 px-8 text-left">Defendants</th>
                          <th className="py-4 px-8 text-left">Category</th>
                          <th className="py-4 px-8 text-left">Status</th>
                          <th className="py-4 px-8 text-left">Latest Upload</th>
                          <th className="py-4 px-8 text-left"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from(queryReults).map((rc) => {
                          return (
                            <tr key={rc._id} className="border-b-2 font-semibold text-xs border-gray-200 hover:bg-gray-100">
                              <td className='py-4 px-8 text-left whitespace-nowrap'>{filteredCases.indexOf(rc) + 1}</td>
                              <td className='py-4 px-8 text-left whitespace-nowrap'>
                                <div className="flex items-center justify-center">
                                  {Array.from(rc.claimants).forEach((rcc) => {
                                    return (<img key={rcc._id} title={rcc.name} className="w-8 h-8 rounded-full border-gray-200 border transform hover:scale-125" src={rcc.avatar} alt="" />)
                                  })}
                                </div>
                              </td>
                              <td className='py-4 px-8 text-left whitespace-nowrap'>
                                <div className="flex items-center justify-center">
                                  {Array.from(rc.defendants).forEach((rcd) => {
                                    return (<img key={rcd._id} title={rcd.name} className="w-8 h-8 rounded-full border-gray-200 border transform hover:scale-125" src={rcd.avatar} alt="" />)
                                  })}
                                </div>
                              </td>
                              <td className='py-4 px-8 text-left whitespace-nowrap'>
                                <span>{rc.category}</span>
                              </td>
                              <td className='py-4 px-8 text-left whitespace-nowrap'>
                                <span>{rc.status}</span>
                              </td>
                              <td className='py-4 px-8 text-left whitespace-nowrap'>
                                <span>{formatDate(rc.updatedAt)}</span>
                              </td>
                              <td className='py-4 px-8 text-left whitespace-nowrap'>
                                <Link path={`/neutral/case-details/${rc._id}`} className="border-2 border-blue-600 hover:bg-blue-300 text-blue-800 font-semibold rounded-lg py-1 px-3">
                                  See Details
                                </Link>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>}
             
            </div>

            {loadingState && <div className="mt-10">
              <LoadingData message="Loading Data..." />
            </div>}
          </div>

        </div>

      </div>
    </div>
  )
}
